// src/hooks/usePlateSyncStatus.js
import { useState, useEffect } from "react";
import { fetchPlateSyncStatus } from "./plateService";

const SYNC_STATUS_POLL_MS = 60000;

/**
 * Per-gate plate sync status for an area, polled every minute.
 * Returns { [plateId]: [{ gate_id, gate_name, gate_direction, display, synced_at, last_attempt_at }] }.
 * null until the first response arrives (or when disabled / no area), so callers can tell "unknown" from "nothing unsynced".
 * Presentation-only, not part of platesByArea. Pass enabled=false for roles without plate access.
 */
export function usePlateSyncStatus(areaId, enabled = true) {
  const [syncStatusByPlate, setSyncStatusByPlate] = useState(null);

  useEffect(() => {
    if (!areaId || !enabled) {
      setSyncStatusByPlate(null);
      return;
    }

    let cancelled = false;
    const poll = async () => {
      try {
        const status = await fetchPlateSyncStatus(areaId);
        if (!cancelled) setSyncStatusByPlate(status);
      } catch (err) {
        console.error("Error fetching plate sync status", err);
      }
    };

    poll();
    const interval = setInterval(poll, SYNC_STATUS_POLL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, [areaId, enabled]);

  return syncStatusByPlate;
}
